// extracted by mini-css-extract-plugin
module.exports = {"tab":"_20RDUTYt _1m8vMwqD _2BQ8VZ00 _26cqdtFW _1AquM3OI _39kXKwTJ _3gJRh9nO _3paVjF5W","selectedTab":"nIenDLKe"};